<template>
    <div>
        <!-- Title when Opened from Work Order View Page-->
        <template v-if="itemId != undefined">
            <div class="form-title">
                <span id="warrantyHeader" v-if="flag == 'update'">Update Warranty Claim</span>
                <span id="warrantyHeader" v-else>Add Warranty Claim</span>
            </div>
        </template>
        <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="WarrantyClaimForm">
            <ev-warranty-claim-form-tabs ref="EvRef" @send-data-to-parent="handleWarrantyClaimTabData"></ev-warranty-claim-form-tabs>

            <div class="form-group">
                <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong id="errorMsg" class="field-error"></strong>
                </div>
            </div>
                <strong id="errorMsg"  class="field-error">{{ submit_error_msg }}</strong>
            <div class="btn-groups">
                <button type="submit" id="cancelWarrantyBtn" class="btn btn-tertiary" v-on:click.prevent="BackWarrantyList">
                <i class="fp-close"> </i>  Cancel
                </button>
            </div>
        </form>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';
import LoadingContent from "@/components/LoadingContent.vue";
import EvWarrantyClaimFormTabs from "./EvWarrantyClaimFormTabs.vue";
Vue.component("loading-content", LoadingContent);
Vue.component("ev-warranty-claim-form-tabs",EvWarrantyClaimFormTabs);

export default {
  name: "WarrantyClaimCreate",
  components: {
        appFooter: () => import('@/components/Footer'),
        EvWarrantyClaimFormTabs
    },
    props: {
        itemData: {
            type: Object,
            required: false,
            default:undefined
        },
        itemId:{
            type: Number,
            required: false,
            default:undefined
        },
        flag:{
            type: String,
            required: false,
            default:undefined
        },
        claimId:{
            type: Number,
            required: false,
            default:undefined
        }
    },
  mixins:[commonMixins, contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: '',
    claim_number: '',
    warranty: null,
    warranty_error_msg: '',
    warrantyArr:[],
    claim_type:'',
    chassis_number:'',
    vin:'',
    part_serial_number:'',
    part_number_item_id:'',
    componentArr:[],
    field_fix_order_number:'',
    odmtr_or_hrmtr_reading:'',
    odmtr_or_hrmtr_read_unit:'',
    odmtr_read_install_purchase:'',
    description: "",
    wo_item_id:null,
    effective_date: "",
    period: "",
    periodTypeArr:[{value:"month",text:"Month"},{value:"year",text:"Year"}],
    periodType:{value:"month",text:"Month"},
    miles:"",
    options: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
    },
    loading:false,
    description_error_msg: '',
    starting_point_value_error_msg: '',
    effective_date_error_msg: '',
    period_error_msg: '',
    warranty_type_error_msg: '',
    claim_number_error_msg: '',
    claim_type_error_msg: '',
    chassis_number_error_msg: '',
    vin_error_msg: '',
    part_number_error_msg: '',
    field_fix_order_number_error_msg: '',
    odmtr_or_hrmtr_reading_error_msg: '',
    odmtr_read_install_purchase_error_msg: '',

    root_cause_part_error_msg: '',
    position_code_error_msg: '',
    a_code_error_msg: '',
    reason_addtl_labor_hrs_error_msg: '',
    unit_price_error_msg: '',
    service_type_error_msg: '',
    ins_spare_parts_num_error_msg: '',
    ins_spare_parts_qty_error_msg: '',
    non_oem_part_error_msg: '',
    non_oem_parts_unit_price_error_msg: '',

    woItemArr:[],
    vendor:'',
    vendorArr:[],
    vendor_claim_number:'',
    cost_claimed_error_msg:'',
    cost_claimed:'',
    cost_claimedEdit:true,
    optionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
    },
    purchase_date_error_msg:'',
    purchase_date:'',
    failure_date_error_msg:'',
    failure_date:'',
    repair_date_error_msg:'',
    repair_date:'',
    installation_date:'',
    field_fix_order_number:'',
    job_card_number:'',
    root_cause_part_item_id:'',
    position_code:'',
    a_code:'',
    b_code:'',
    damage_code:'',
    labor_code:'',
    addtl_labor_hrs:'',
    reason_addtl_labor_hrs:'',
    services_description:'',
    unit_price:'',
    service_type:'',
    ins_parts_sr_num:'',
    ins_part_num_item_id:'',
    ins_spare_parts_qty:'',
    non_oem_part_item_id:'',
    non_oem_parts_qty:'',
    non_oem_parts_unit_price:'',
    conditions_found:'',
    work_performed:'',
    probable_cause:'',
    claim_notes:'',
    model:'',
    make:'',
    year:'',
    truck_type:'',
    unit_no:'',
    wo_item:'',
    assigned_facility:'',
    isTechnician:false,
    role:'',
    woAmount:0,
    collected:'no',
    work_order_id:'',
    claimTypeArr:[],
    tabData: null,
    sendingTabData: null,
    sendingLineItemData: null,
    submit_error_msg: '',
    nextClaimId: null,
  }),
  watch: {
        wo_item: function(val) {

            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            if(val != null && val != '' && val.vehicle_id){

                $.ajax({
                    url: process.env.ROOT_API + "/asset/"+val.vehicle_id,
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer "+localStorage.getItem("tkn"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    crossDomain: true,
                    dataType:"json",

                    success: function (data) {
                        //if data is edit than dont make model id blank
                        if (data.status == "success") {
                            self.vin = data.content.vin;
                            self.unit_no = data.content.unit_no;
                            self.truck_type = data.content.vtCode+' | '+data.content.vtName;
                            self.assigned_facility = data.content.plCode+' | '+data.content.plName;
                            self.net_book_value = data.content.net_book_value;
                            self.make = data.content.vmCode+' | '+data.content.vmName;
                            if (data.content.vmodelsCode != null && data.content.vmodelsCode != ''){

                                self.model = data.content.vmodelsCode+' | '+data.content.vmodelsName;

                            }
                            if (data.content.year != null){

                                self.year = data.content.year;

                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.Registerbtn = "Register";
                        self.generateStatusCodeMessage(jqXHR,true,'asset-data')
                    }
                });
            }
            if (val != null && val != '' && val.amount){
                self.woAmount = val.amount;
            }

        },
  },
  mounted: function() {
        var self = this;
        // self.getPermissions();
        // self.loadFieldData(['claim_types']);
        var path = window.location.pathname;
        var segments = path.split("/");

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
            // var userJson = JSON.parse(userObj);
            if (userObj.roles.length > 0) {
                self.role = userObj.roles[0].name;
                // if(self.role.toLowerCase() == 'technician'){
                //     self.isTechnician = true;
                // }
            }
        }

        if (self.itemId != undefined){
            console.log(self.itemData);
            // self.workOrderItemFetch(self.itemId);
            self.wo_item = {text:self.itemData.wo_no+' | '+self.itemData.vmrs_name+' | '+self.itemData.task_name,value:self.itemData.woItemId,vehicle_id:self.itemData.vehicle_id,amount:self.itemData.amount};
            if (self.claimId != undefined && self.claimId != '' && self.claimId > 0){
                self.loadClaimData(self.claimId);
            }else{
                setTimeout(function(){
                    self.getClaimCode();
                },500);
            }
        }else{
            if (segments[3]){

                self.loadClaimData(segments[3]);

            }else{
                self.getClaimCode();
            }
        }
  },
  methods: {
    validateInput(evt) {
      var self = this;
      evt = (evt) ? evt : window.event;
      if(evt.target.value > 999999.99) {
        self.cost_claimedEdit = false;
        self.cost_claimed_error_msg = "Amount value exceed";
      } else {
        self.cost_claimedEdit = true;
        self.cost_claimed_error_msg = "";
      }

    },
    integerCheck: function (evt) {
      var self = this;
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();
        } else {
            if(self.cost_claimedEdit) {
              return true;
            } else {
              evt.preventDefault();
            }
            return true;
        }
    },
    getClaimCode(){
        var self = this;
        self.$parent.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/claim/code",
            type: "POST",
            headers: {
                Accept: "application/json",
                "Access-Control-Allow-Origin": "*",
                "Authorization": "Bearer " + localStorage.getItem("tkn"),
                "Access-Control-Allow-Headers":
                "Origin, Content-Type, Authorization,X-Requested-With",
                "Cache-Control": "no-cache"
            },
            dataType: "json",
            success: function (data) {
                self.$parent.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.claim_number = data.content;
                }
            },
            error: function (jqXHR, exception) {
                self.$parent.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'customer-code')
            }
        });
    },
    callEvTabs(claimId,flag){
      var self = this;
      this.$refs.EvRef.updateTabData(self.sendingTabData,claimId,flag);
      this.$refs.EvRef.updateLineItemData(self.sendingLineItemData);
    },

    loadClaimData:function(claimId,flag = null){
        var self = this;

        self.$parent.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/warranty-claim/fetch/"+claimId,
            type: "GET",
            headers: {
                'Accept': 'application/json',
                "Access-Control-Allow-Origin": '*',
                "Authorization": "Bearer "+localStorage.getItem("tkn"),
                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                "Cache-Control": "no-cache"
            },
            data: {
              claimType: "EV_CLAIM",
            },
            crossDomain: true,
            dataType: "json",
            success: function (data) {
                self.$parent.loading = false;
                self.sendingTabData = data.content.tabData;
                self.sendingLineItemData = data.content.line_item_data;
                self.callEvTabs(claimId,flag);
            },
            error: function (jqXHR, exception) {
                self.$parent.loading = false;
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR,true,'asset-group-warranties-search')
            }
        });
    },

    onSearchComponent(search, loading) {
        var self = this;
        if (search.length > 1) {
            loading(true);
            self.searchField(loading, search, 'component', '');
        }
    },

    onSearchVendor(search, loading) {
        var self = this;
        self.po_error_msg = "";
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'bill_vendor', '');
        }
    },
    onSearchwoitem(search, loading) {
        var self = this;
        self.po_error_msg = "";
        if (search.length > 6) {

            loading(true);
            self.searchField(loading, search, 'wo_item', '');
        }
    },
    onSearchWarranty(search, loading) {
      var self = this;
      if (search.length > 1) {
        loading(true);
        console.log('loading => '+ loading);
        self.searchField(loading, search, 'warranty', '');
      }
    },
    BackWarrantyList() {
      var self = this;
      if (self.itemId != undefined){
        self.$parent.cancelWarrantyClaim();
      }else{
        self.$router.push("/warranty-claim/list");
      }
    },
    CreateWarrantyClaim(flag) {

        var self = this;
        var error = false;

        if (self.collected == 'yes'){
            self.$swal('','You have already created the collection for this claim','info');
            return;
        }

        self.claim_number_error_msg = "";
        self.warranty_error_msg = "";
        self.claim_type_error_msg = "";
        self.chassis_number_error_msg = "";
        self.vin_error_msg = "";
        self.part_number_error_msg = "";
        self.field_fix_order_number_error_msg = "";
        self.odmtr_or_hrmtr_reading_error_msg = "";
        self.odmtr_read_install_purchase_error_msg = "";
        self.purchase_date_error_msg = "";
        self.failure_date_error_msg = "";
        self.repair_date_error_msg = "";
        self.root_cause_part_error_msg = "";
        self.position_code_error_msg = "";
        self.a_code_error_msg = "";
        self.reason_addtl_labor_hrs_error_msg = "";
        self.unit_price_error_msg = "";
        self.service_type_error_msg = "";
        self.ins_spare_parts_num_error_msg = "";
        self.ins_spare_parts_qty_error_msg = "";
        self.non_oem_part_error_msg = "";
        self.non_oem_parts_unit_price_error_msg = "";
        self.submit_error_msg = "";

        if (self.tabData == null){
          error = true;
          self.submit_error_msg = "All Required Fields in the tabs have not been filled!";
        }
        if (!error) {

            self.$parent.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            var id = '';
            if (self.itemId != undefined){
                if (self.claimId != '' && self.claimId != undefined){
                    id = self.claimId;
                }
            }else{
                if (segments[3]){
                    id = segments[3];
                }
            }

            if(self.nextClaimId != null){
              id = self.nextClaimId;
            }
            if (id != '')
            {
                $("#createWarrantyBtn").val("Updating ...");
                $("#createWarrantyBtn").prop("disabled", true);
                $("#cancelWarrantyBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {
                    $("#createAndContinueWarrantyBtn").val("Saving ...");
                    $("#createWarrantyBtn").prop("disabled", true);
                    $("#createAndContinueWarrantyBtn").prop("disabled", true);
                    $("#cancelWarrantyBtn").prop("disabled",true);
                }else{
                    $("#createWarrantyBtn").val("Saving ...");
                    $("#createWarrantyBtn").prop("disabled", true);
                    $("#createAndContinueWarrantyBtn").prop("disabled", true);
                    $("#cancelWarrantyBtn").prop("disabled",true);
                }
            }
            var fields = $('#WarrantyClaimForm').serializeArray();
            fields.push({name: "id", value: id});
            fields.push({name: "tab_data", value: JSON.stringify(self.tabData)});

            $.ajax({
                url: process.env.ROOT_API + "/warranty-claim/create",
                type: "POST",
                data: fields,
                headers: {
                    "Accept": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Authorization": "Bearer " + localStorage.getItem("tkn"),
                    "Access-Control-Allow-Headers":
                        "Origin, Content-Type, Authorization,X-Requested-With",
                    "Cache-Control": "no-cache"
                },
                dataType: "json",
                success: function (data) {
                    self.$parent.loading = false;
                    if (id != '')
                    {
                        $("#createWarrantyBtn").val("Update");
                        $("#createWarrantyBtn").prop("disabled", false);
                        $("#cancelWarrantyBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueWarrantyBtn").val("Save and Continue");
                            $("#createWarrantyBtn").prop("disabled", false);
                            $("#createAndContinueWarrantyBtn").prop("disabled", false);
                            $("#cancelWarrantyBtn").prop("disabled",false);

                        }else{

                            $("#createWarrantyBtn").val("Save");
                            $("#createWarrantyBtn").prop("disabled", false);
                            $("#createAndContinueWarrantyBtn").prop("disabled", false);
                            $("#cancelWarrantyBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#WarrantyForm").trigger("reset");
                            self.wo_item = '';
                            self.claim_number = '';
                            self.purchase_date = '';
                            self.failure_date = '';
                            self.repair_date = '';
                            self.installation_date = '';
                            self.cost_claimed = '';
                            self.claim_type = '';
                            self.description = '';
                            self.vendor_claim_number = '';
                            self.vendor = '';

                        }else{
                            if (self.itemId != undefined){
                                self.$parent.create_warranty_claim = false;
                                self.$parent.taskArr = [];
                                self.claimId = '';
                                self.claim_number = '';
                                self.$parent.workOrderItemData();
                            }else{
                                self.$router.push("/warranty-claim/list");
                            }
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.$parent.loading = false;
                    if (id != '')
                    {
                        $("#createWarrantyBtn").val("Update");
                        $("#createWarrantyBtn").prop("disabled", false);
                        $("#cancelWarrantyBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            // $("#VehicleStatusForm").trigger("reset");

                            $("#createAndContinueWarrantyBtn").val("Save and Continue");
                            $("#createWarrantyBtn").prop("disabled", false);
                            $("#createAndContinueWarrantyBtn").prop("disabled", false);
                            $("#cancelWarrantyBtn").prop("disabled",false);

                        }else{

                            $("#createWarrantyBtn").val("Save");
                            $("#createWarrantyBtn").prop("disabled", false);
                            $("#createAndContinueWarrantyBtn").prop("disabled", false);
                            $("#cancelWarrantyBtn").prop("disabled",false);

                        }
                    }
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");

                            self.$router.push("/");
                        }
                        $("#errorMsg").html(jqXHR.responseJSON.message);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);
                    }
                }
            });
        }


    },
    handleWarrantyClaimTabData(tabData,flag){
      var self = this;
      var path = window.location.pathname;
      var segments = path.split("/");
      self.tabData = tabData;
      self.nextClaimId = self.tabData.claimId;
      if(flag ==='delete_attached' && segments[3]){
          self.loadClaimData(segments[3],flag);
      }else{
        self.CreateWarrantyClaim();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/EVWarrantyClaimForm.vue